export default (r, xBorder, yBorder) => {
  const hBorder = Math.min(xBorder, r.width / 2);
  const vBorder = Math.min(yBorder, r.height / 2);
  return r.merge({
    left: r.left + hBorder,
    right: r.right - hBorder,
    width: r.width - 2 * hBorder,
    top: r.top + vBorder,
    bottom: r.bottom - vBorder,
    height: r.height - 2 * vBorder
  });
};
